import React from "react";
import { Box, Typography } from "@mui/material";

export default function Home() {
  return (
    <Box
      sx={{
        backgroundImage: `url("Assets/Images/background2.png")`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        py: { xs: 2, md: 10 },
        height: { xs: 100, sm: 100, md: 100 },
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        px: { xs: 1, md: 4 },
      }}
    >
      <Box
        component="img"
        src="Assets/Images/logo.png"
        alt="uBCoded Logo"
        sx={{
          width: { xs: 100, sm: 200, md: 220 },
          fontWeight: "400",
          maxHeight: { xs: 100, sm: 140, md: 250 },
          marginRight: { xs: 1, sm: 2, md: 3 },
          objectFit: "contain",
        }}
      />

      <Typography
        variant="h2"
        component="h1"
        sx={{
          flex: 1,
          textAlign: "left",
          fontSize: { xs: 32, sm: 100, md: 170, lg: 200, xl: 250 },
          fontWeight: "550",
          color: "#0b2538ff",
          letterSpacing: { xs: 4, sm: 10, md: 20, lg: 50, xl: 60 },
          ml: { xs: 2, md: 0, xl: 2 },
          mt: { xs: 0, md: 10 },
          mb: { xs: 0, md: 5, xl: 5 },
          whiteSpace: "nowrap",
        }}
      >
        uBCoded
      </Typography>
      {/* Navigation Links */}
    </Box>
  );
}
